import React from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const BrowseCard = (props: {
  title: string;
  description: string;
  thumbnail: string;
  to: string;
}) => (
  <Link to={props.to}>
    <Box
      bg="gray.700"
      border="1px solid"
      borderColor="gray.700"
      borderRadius="8px"
      overflow="hidden"
      p="10px"
      mb="6px"
    >
      <Flex alignItems="center">
        <Image
          src={props.thumbnail}
          alt=""
          width="56px"
          height="56px"
          borderRadius="full"
          objectFit="cover"
          flexShrink={0}
        />
        <Box pl="12px" flexGrow={1} flex="1">
          <Text
            as="h4"
            fontSize="16px"
            lineHeight="21px"
            fontWeight="700"
            mb="2px"
          >
            {props.title}
          </Text>
          <Text fontSize="14px" lineHeight="18px">
            {props.description}
          </Text>
        </Box>
      </Flex>
    </Box>
  </Link>
);

export default BrowseCard;
